module.exports = __webpack_public_path__ + "fonts/SUIT-ExtraBold.be6d5d0c.woff2";